import React, { useEffect } from "react";
import { ModalConstructor } from "../ModalConstructor";
import {
    ContentTypography,
    ServiceModalInnerContainerStyles,
} from "./ServiceModal.styles";
import { SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE } from "../ServiceFunctionsModal.types";

export function CommentCreationErrorModal({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: (open: boolean) => void;
}) {
    useEffect(() => {
        if (open) {
            const timeout = setTimeout(() => {
                handleClose();
            }, SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE);

            return () => {
                clearTimeout(timeout);
            };
        }
    }, [open]);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <ModalConstructor
            onClose={handleClose}
            open={open}
            modalTitle={"Beitrag konnte nicht erstellt werden!"}
            modalContent={
                <ContentTypography>Bitte versuche es erneut.</ContentTypography>
            }
            isBorderRadiusVisible={true}
            isInsideClosingButtonVisible={false}
            isOutsideClosingButtonVisible={true}
            modalInnerContainerStyles={ServiceModalInnerContainerStyles}
        />
    );
}
